import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProofSection() {
  return <section className="bg-cream py-24 px-6" data-id="element-168">
      <div className="max-w-4xl mx-auto text-center" data-id="element-169">
        <FadeIn data-id="element-170">
          <div className="relative" data-id="element-171">
            <span className="absolute -top-10 -left-6 text-8xl text-amber/20 font-heading leading-none" data-id="element-172">
              "
            </span>
            <p className="text-2xl md:text-3xl leading-relaxed text-charcoal font-heading relative z-10" data-id="element-173">
              This isn't just a book; it's a bridge. When your parents have a
              physical "Action Map" in their hands, their heart rate drops and
              their confidence rises.
            </p>
            <span className="absolute -bottom-16 -right-6 text-8xl text-amber/20 font-heading leading-none" data-id="element-174">
              "
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-175">
          <div className="mt-16 inline-block bg-white px-8 py-6 rounded-2xl shadow-sm border border-warmGray" data-id="element-176">
            <p className="text-lg md:text-xl font-medium text-warmBrown" data-id="element-177">
              Within 15 minutes of reading, most parents perform their first{' '}
              <br className="hidden md:block" data-id="element-178" />
              <strong className="text-charcoal font-bold" data-id="element-179">
                "Photo Rescue" entirely on their own.
              </strong>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}